import React from "react"
import Flink from '~/components/shared/flink'
import { useTheme }  from '~/contexts/ThemeContext'
import { notBlank, imgSize, jnstyls} from '~/utils/helpers'

import { cta_link, aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/home/contents.module.scss"


const is_hero = (type) => {
  const heroes = ['full_bleed', 'hero_wide', 'hero']
  return heroes.includes(type)
}


const Title = ({ block, item, index, pstyles={}, from }) => {
  const { url, copy } = item

  let use_link = notBlank(url)
  const hero_types = ['hero','hero_wide','full_bleed']
  if (hero_types.includes(block.type) && from === 'from_ovrly' && use_link) use_link = false

  const is_journ = block.type === 'journal'
  const is_first = index === 0 
  const chunky_title = block?.chunky_title_link
  
  let use_font = false
  if (from === 'from_ovrly' && block?.overlay_font) use_font = is_hero(block.type) && block.overlay_font
  if (from === 'from_capts' && block?.capt_font) use_font = is_hero(block.type) && block.capt_font
  if (use_font) {
    use_font = styles[`use_${use_font}`]
  }

  let wrap_styles = [styles.title, styles[from], pstyles.htitle]
  if (use_font) wrap_styles.push(use_font)

  let el_styles = [styles.htitle, pstyles.htitle]
  if (chunky_title) el_styles.push(styles.chunky_title)

  return (
    <div className={jnstyls(wrap_styles)} txti={block.id}>
      {!!use_link && (
        <Flink href={url} className={jnstyls([styles.htitle_link, pstyles.htitle_link])}>
          {is_first && (
            <h1 
              className={jnstyls(el_styles)} 
              dangerouslySetInnerHTML={{ __html: copy }} 
              ctitle={chunky_title ? '' : undefined}
            />
          )}
          {!is_first && (
            <h2 
              className={jnstyls(el_styles)} 
              dangerouslySetInnerHTML={{ __html: copy }} 
              ctitle={chunky_title ? '' : undefined}
            />
          )}
        </Flink>
      )}
      {!use_link && (
        <>
          {is_first && (
            <h1 
              className={jnstyls(el_styles)} 
              dangerouslySetInnerHTML={{ __html: copy }} 
              ctitle={chunky_title ? '' : undefined}
            />
          )}
          {!is_first && (
            <h2 
              className={jnstyls(el_styles)} 
              dangerouslySetInnerHTML={{ __html: copy }} 
              ctitle={chunky_title ? '' : undefined}
            />
          )}
        </>
      )}
    </div>
  )
}

const ImgTitle = ({ block, from, img_title, desk_height, mobi_height, title, klass, pstyles={} }) => {
  const { url, copy } = title

  const dheight = desk_height ? desk_height : false
  const mheight = mobi_height ? mobi_height : false

  let use_link = notBlank(url)
  const hero_types = ['hero','hero_wide','full_bleed']
  if (hero_types.includes(block.type) && from === 'from_ovrly' && use_link) use_link = false

  // const block_hero = is_hero(block.type)

  return (
    <>
      {dheight && (
        <style>
          {`@media only screen and (min-width: 800px) {
            .${klass}.${styles.img_title} {
              max-height: ${dheight};
            }
          }`}
        </style>
      )}
      {mheight && (
        <style>
          {`@media only screen and (max-width: 800px) {
            .${klass}.${styles.img_title} {
              max-height: ${mheight};
            }
          }`}
        </style>
      )}

      <div className={jnstyls([styles.htitle, pstyles.htitle])} imgt={block.id}>
        {!!use_link && (
          <Flink href={url} className={styles.htitle_link}>
            <img 
              className={`${klass} ${styles.img_title}`} 
              src={img_title.includes('.png') ? img_title : imgSize(img_title,500)} 
              alt={notBlank(copy) ? copy : ''} 
              width={200} height={50} 
            />
          </Flink>
        )}
        {!use_link && (
          <img 
            className={`${klass} ${styles.img_title}`} 
            src={img_title.includes('.png') ? img_title : imgSize(img_title,500)} 
            alt={notBlank(copy) ? copy : ''} 
            width={200} height={50} 
          />
        )}
      </div>
    </>
  )
}


const Subtitle = ({ block, from, item, index, pstyles={} }) => {
  const { url, copy } = item
  
  const from_style = from ? styles[from] : ''
  let use_link = notBlank(url)
  const hero_types = ['hero','hero_wide','full_bleed']
  if (hero_types.includes(block.type) && from === 'from_ovrly' && use_link) use_link = false

  return (
    <div className={jnstyls([styles.hsubtitle, pstyles.hsubtitle, from_style])} subt={block.id}>
      { use_link ? (
        <Flink href={url} className={styles.htitle_link}>
          <>{copy}</>
        </Flink>
      ) : (
        <>{copy}</>
      )}
    </div>
  )
}


const Ctas = ({ block, from, item, index, pstyles={} }) => {
  const { setGender } = useTheme()

  const is_overlay = from === 'from_ovrly' && !block.btn_cta_style
  const from_style = from ? styles[from] : ''
  
  const checkLink = (link) => {
    let use_link = notBlank(link.url)
    const hero_types = ['hero','hero_wide','full_bleed']
    if (hero_types.includes(block.type) && from === 'from_ovrly' && notBlank(block.url)) use_link = false

    return use_link
  }

  const is_journ = block.type === 'journal'

  const handleGenderClick = (url) => {
    setGender(url.replace('/?g=',''))
    setTimeout(()=>{
      window.scrollTo(...[0, 0])
      const element = document.querySelector('#header')
      if (!element) return
      element.style.transform = `translate(0, 0%)`;
    }, 20)
  }

  return (
    <div className={jnstyls([styles.copy_cta, pstyles.copy_cta, from_style])} hctas={block.id}>
      {item.links.map( (link, linkIndex) => 
        <React.Fragment key={`ctas${index}-${linkIndex}`}>
          {(checkLink(link) && link.url.includes('/?g=')) ? (
            <button 
              type="button"
              className={[aria_btn, cta_link].join(' ')}
              onClick={(e)=>{ handleGenderClick(link.url) }}
              ovrlybtn={is_overlay ? 'true' : undefined}
            >
              <span>{link.copy}</span>
            </button>
          ) : !checkLink(link) ? (
            <div 
              className={[aria_btn, cta_link].join(' ')}
              ovrlybtn={is_overlay ? 'true' : undefined}
              fcta=''
            >
              <span>{link.copy}</span>
            </div>
          ) : (
            <Flink 
              href={link.url} 
              className={cta_link}
              ovrlybtn={is_overlay ? 'true' : undefined}
            >
              <span>{link.copy}</span>
            </Flink>
          )}
        </React.Fragment>
      )}
    </div>
  )
}


const Body = ({ block, from, copy, index, pstyles={} }) => {
  const from_style = from ? styles[from] : ''

  return (
    <>
      <div 
        className={jnstyls([styles.copy_body, pstyles.copy_body, from_style])} 
        dangerouslySetInnerHTML={{ __html: copy }} 
        hbod={block.id}
      />
      {block.id === 1263 && (
        <style>
          {`[mid="1263"] .${styles.copy_body} {
            max-width: 350px;
          }`}
        </style>
      )}
      {block.id === 1215 && (
        <style>
          {`[mid="1215"] .${styles.copy_body} {
            max-width: 350px;
          }`}
        </style>
      )}
    </>
  )
}



export { Title, ImgTitle, Subtitle, Ctas, Body }

